var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8.71436C8 4.29578 11.5786 0.714355 16 0.714355C20.4214 0.714355 24 4.29578 24 8.71436V12.1429H28.5714C30.4643 12.1429 32 13.6786 32 15.5715V30.4286C32 34.2144 28.9286 37.2858 25.1429 37.2858H6.85714C3.07 37.2858 0 34.2144 0 30.4286V15.5715C0 13.6786 1.535 12.1429 3.42857 12.1429H8V8.71436ZM11.4286 12.1429H20.5714V8.71436C20.5714 6.18936 18.5214 4.14293 16 4.14293C13.4786 4.14293 11.4286 6.18936 11.4286 8.71436V12.1429ZM9.71429 19.0001C10.6643 19.0001 11.4286 18.2358 11.4286 17.2858C11.4286 16.3358 10.6643 15.5715 9.71429 15.5715C8.76429 15.5715 8 16.3358 8 17.2858C8 18.2358 8.76429 19.0001 9.71429 19.0001ZM22.2857 15.5715C21.3357 15.5715 20.5714 16.3358 20.5714 17.2858C20.5714 18.2358 21.3357 19.0001 22.2857 19.0001C23.2357 19.0001 24 18.2358 24 17.2858C24 16.3358 23.2357 15.5715 22.2857 15.5715Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 14.2144,
    r: 10.5,
    fill: "url(#paint0_linear_8_24)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1594 18.7144V13.3944C28.1594 13.1517 28.1594 12.9044 28.1594 12.6524C28.1687 12.391 28.1734 12.125 28.1734 11.8544C27.8654 12.1344 27.5247 12.3817 27.1514 12.5964C26.778 12.8017 26.386 12.9417 25.9754 13.0164L25.7514 11.0284C25.994 11.0097 26.2507 10.949 26.5214 10.8464C26.8014 10.7437 27.0767 10.6177 27.3474 10.4684C27.618 10.319 27.8607 10.1604 28.0754 9.99236C28.29 9.81502 28.4534 9.64236 28.5654 9.47436H30.4834V18.7144H28.1594Z",
    fill: "#2D3949"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_24",
    x1: 18,
    y1: 14.2144,
    x2: 39,
    y2: 14.2144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 36.5714,
    fill: "white",
    transform: "translate(0 0.714355)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.1e7f1e28b266e1a6c28c338d71215e08.svg";
export { ForwardRef as ReactComponent };